module.exports = __webpack_public_path__ + "static/media/logo.db35701d.svg";